module.exports = __webpack_public_path__ + "img/kinmen_main_mobile.ea6a2d40.png";